(function () {
    'use strict';

    angular
        .module('searchModule')
        .controller('SearchRefineFacetsController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        // RefineFacetId => Template url
        var byRefineFacetGroupTemplateUrls = {
            2024: '/app/shared/searchBox/byRefineFacetGroup-controlStatus.tpl.html',
            2041: '/app/shared/searchBox/byRefineFacetGroup-initiativeCompletionStatus.tpl.html',
            2042: '/app/shared/searchBox/byRefineFacetGroup-publishedDate.tpl.html'
        };

        $scope.getByRefineFacetGroupTemplateUrl = function (refineFacetId) {
            var templateUrl = byRefineFacetGroupTemplateUrls[refineFacetId] || '/app/shared/searchBox/byRefineFacetGroup-default.tpl.html';

            return templateUrl;
        }
    }
})();
